<template>
  <div :class="[outerClass, colSize]">
    <label v-if="label" class="block" :class="labelClass" :style="labelStyle">{{ __(label) }}</label>
    <InputMask style="width:100%" :disabled="isFormDisabled" :name="fieldName" :mask="mask" :placeholder="placeholder"
      class="w-full rounded-md border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black-500/50"
      v-focus="isFocus" v-model="field" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import InputMask from 'primevue/inputmask';
import { __ } from '@pages/Helper/utils.js'

const props = defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: null,
  },
  size: {
    type: String,
    default: null
  },
  isFocus: {
    type: Boolean,
    default: false
  },
  isFormDisabled: {
    type: Boolean,
    default: false
  },
  mask: {
    type: String,
    required: true
  },
  placeholder: {
    type: String,
    default: null
  },
  labelClass: {
    type: String,
    default: null
  },
  labelStyle: {
    type: [Object, String],
    default: null
  },
  inRepeater: {
    type: Boolean,
    default: false
  },
});

const field = defineModel('field');
const colSize = props?.size ? 'col-' + props.size : 'col';
const outerClass = ref('field');

if (props.inRepeater) {
  outerClass.value = null;
}

</script>

<style lang="scss" scoped></style>
